/** sessionStorage key for the conflict search persisted state. */
export const CONFLICT_SEARCH_STORAGE_KEY = 'conflict-search-state';
